import { Component, Input, OnInit, SimpleChanges } from '@angular/core';;
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

@Component({
  selector: 'app-pie-shared',
  templateUrl: './pie-shared.component.html',
  styleUrls: ['./pie-shared.component.scss'],
})
export class PieSharedComponent implements OnInit{
 
  @Input() chartId;
  @Input() charParam;
  @Input() chartData; 
  @Input() chartType;
  @Input() innerRadius = 50;
  @Input() height = 120;
  root: any;
  data: any[];
 
  constructor(
  ) {
   
  }

  ngOnInit() {    
   
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.chartId && this.chartData && this.chartType){
      this.data = [];
      this.data.push({
        text: this.chartType,
        value: this.chartData,
      })
      this.data.push({
        text: '',
        value: 100 - parseInt(this.chartData),
      })
      setTimeout(() => {
        this.renderChart()
      }, 100);
    }
  }
  renderChart(){
    let root = am5.Root.new(this.chartId);
    root.setThemes([
      am5themes_Animated.new(root)
    ]);
    if (root._logo) {
      root._logo.dispose();
    }
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        endAngle: 270
      })
    );
    let series0 = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "text",
        innerRadius: am5.percent(this.innerRadius)
      })
    );

    series0.set("colors", am5.ColorSet.new(root, {
      colors: [
        am5.color("#F68A1F"),
        am5.color("#F7F9FA"),
      ]
    }))


    // series0.set("colors", colorSet);

    series0.ticks.template.set("forceHidden", true);
    series0.labels.template.set("forceHidden", true);
    series0.slices.template.set("toggleKey", "none");
    series0.slices.template.set("tooltipText", "");

    series0.data.setAll(this.data);
  }
}

